import * as React from 'react';

import { Product } from '@notino/web-tracking/dist/types/package/ga4/events/products';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { useTrackingContext } from '@context/tracking/TrackingContext';
import { ProductEventWither } from '@helpers/googleTagManager';

type TUseTrackSelectCb = {
  product: Product;
  timing: number;
  variant: 'mobile' | 'desktop';
};

export const useTrackSelect = (timeOfStart: number) => {
  const { getVariant, getTimeFromInit } = useTrackingContext();
  const { product, currentVariant } = useProductDetailContext();

  return React.useCallback(
    (cb: (props: TUseTrackSelectCb) => void) => {
      cb({
        product: ProductEventWither()
          .withProduct(product)
          .withVariant(currentVariant)
          .build(),
        timing: getTimeFromInit(timeOfStart),
        variant: getVariant(),
      });
    },
    [currentVariant, getTimeFromInit, getVariant, product, timeOfStart]
  );
};
